import { useCallback } from 'react';

import { DestinationType, LockboxStatus } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

interface Result {
  status?: string;
  statusTitle?: string;
}

const useGetClaimRepaymentCompleteStatus = () => {
  const { originalLockbox } = useLockboxDetailsStore();

  const getClaimRepaymentCompleteStatus = useCallback((): Result => {
    const hasClaims = !!originalLockbox?.claimRepayments?.length;

    if (originalLockbox?.lockboxStatus === LockboxStatus.COMPLETED && !hasClaims && originalLockbox?.remainder?.destinationType === DestinationType.PLAN_ACCOUNT) {
      return { status: LockboxStatus.APPROVED, statusTitle: LockboxStatus.APPROVED };
    };

    if (originalLockbox?.lockboxStatus === LockboxStatus.COMPLETED && hasClaims && originalLockbox?.remainder?.destinationType === DestinationType.CHECK) {
      return { status: LockboxStatus.PARTIALLY_APPROVED, statusTitle: LockboxStatus.PARTIALLY_APPROVED };
    };

    if (originalLockbox?.lockboxStatus === LockboxStatus.COMPLETED && hasClaims && originalLockbox?.remainder?.destinationType === DestinationType.PLAN_ACCOUNT) {
      return { status: LockboxStatus.PARTIALLY_APPROVED, statusTitle: LockboxStatus.PARTIALLY_APPROVED };
    };

    if (originalLockbox?.lockboxStatus === LockboxStatus.COMPLETED && hasClaims && !originalLockbox?.remainder) {
      return { status: LockboxStatus.APPROVED, statusTitle: LockboxStatus.APPROVED };
    };

    if (originalLockbox?.lockboxStatus === LockboxStatus.COMPLETED && !hasClaims && originalLockbox?.remainder?.destinationType === DestinationType.CHECK) {
      return { status: LockboxStatus.DECLINED, statusTitle: LockboxStatus.COMPLETED };
    };

    return { status: originalLockbox?.lockboxStatus, statusTitle: originalLockbox?.lockboxStatus };
  }, [originalLockbox?.claimRepayments?.length, originalLockbox?.remainder, originalLockbox?.lockboxStatus]);

  return { getClaimRepaymentCompleteStatus };
};

export default useGetClaimRepaymentCompleteStatus;
